export default __webpack_public_path__ + "static/Axiforma-Bold-dac0c873a8c3b37d17fbfb2c5ccf566f.woff2";